<!-- Preloader -->
<div id="preloader" *ngIf="isSpinnerVisible"></div>
